import { createListenerMiddleware } from '@reduxjs/toolkit';

import { fetchPlayerConfigAction } from '../apiActions/fetchPlayerConfigAction';
import type { CoreRootState } from '../CoreStore';
import { gameStateActions } from '../slices/game/slice';

export const playerConfigMiddleware = createListenerMiddleware();

playerConfigMiddleware.startListening({
  actionCreator: fetchPlayerConfigAction.fulfilled,
  effect: (action, { dispatch, getState }) => {
    const state = getState() as CoreRootState;
    const tableId = state.config.session?.tableId;
    const netWinBalanceMap = state.config.playerConfig?.netWinBalanceMap || {};

    if (tableId && netWinBalanceMap[tableId]) {
      dispatch(gameStateActions.setNetPosition(netWinBalanceMap[tableId]));
    }
  },
});
